

























import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalHelp extends ModalComponentBaseVue {
  dialog: boolean = false

  helpUrl1 = '/api/help/カウンター業務編.pdf'

  helpUrl2 = '/api/help/資料管理編.pdf'

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  onClickOk(): void {
    this.close()
  }

  onClickCancel(): void {
    this.close()
  }

  onClickPrint(): void {
    const element = document.querySelector<HTMLElement>(
      '.v-dialog--active #modal-help'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }
}
